import React from 'react';
import Icon from './Icon';
import useTheme from '../hooks/useTheme';

/** Light/Dark шилжүүлэгч — icon-only 40px товч (aria-label заавал). */
export default function ThemeToggle({ size = 40, style }: { size?: number; style?: React.CSSProperties }) {
  const { resolved, toggle } = useTheme();
  const dark = resolved === 'dark';
  return (
    <button type="button" className="sh-iconbtn" onClick={toggle} style={{ width: size, height: size, ...style }}
      aria-label={dark ? 'Гэрэлтэй горим' : 'Харанхуй горим'} title={dark ? 'Гэрэлтэй горим' : 'Харанхуй горим'}>
      <Icon name={dark ? 'sun' : 'moon'} size={20} />
    </button>
  );
}
